import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Label } from "./Reveal";

const ITEMS = [
  {
    q: "What is Mended Alchemy?",
    a: "Mended Alchemy is a life and parenting coaching and edupreneurial venture, founded on a simple yet powerful belief: when we invest in ourselves, we change the way we experience life, relationships and parenting. Our work is centred on thriving mothers, thriving parents and, ultimately, thriving children. Through personalised coaching, educational programmes and thoughtfully created digital and physical resources, Mended Alchemy supports mothers in their personal growth and parents in navigating the many dimensions of parenting with greater self-awareness, intention and confidence. Because the journey is interconnected. When mothers are supported and parents become more conscious of themselves, children benefit from the relationships and environments we create around them. At Mended Alchemy, we believe meaningful change begins within and when that change extends into parenting, it can create a stronger foundation for children to thrive.",
  },
  {
    q: "What is the Mother's Transformation Journey about?",
    a: "The Mother's Transformation Journey (Life Coaching) is a personalised space to explore the areas of life that matter to you, ranging from identity, relationships and emotional patterns to boundaries, confidence, purpose, wellbeing and personal growth. The scope is intentionally expansive and evolves around where you are today, what you are experiencing and what you want to understand, change or create in your life.",
  },
  {
    q: "What resources and products are available through Mended Alchemy?",
    a: "Currently, our collection includes the e-book Mumma Can Heal Me, a thoughtful resource for mothers who want to prioritise their wellbeing, understand themselves better and invest in their personal growth. As Mended Alchemy evolves, our digital and physical products will be thoughtfully created to offer meaningful value, practical insights and continued support across your journey of life and parenting.",
  },
  {
    q: "How quickly can we expect to see changes in our child's behavior?",
    a: "Most parents report noticeable shifts in atmosphere within 5 to 7 days of implementing our core boundary and connection protocols.",
  },
  {
    q: "Do both parents need to attend the consultation calls?",
    a: "While having both co-parents aligned yields the fastest results, one dedicated parent can absolutely drive positive change in the home.",
  },
  {
    q: "Is coaching done virtually or in-person?",
    a: "All consultations are conducted via secure high-definition video calls, making it effortless to fit into busy parent schedules.",
  },
  {
    q: "Does my child need to attend the sessions?",
    a: "No. All sessions are designed for parents — children are not required to attend. The work focuses on understanding your child's world and reshaping your responses, which naturally transforms their behaviour at home.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq-section"
      data-testid="faq-section"
      className="py-20 lg:py-32 px-4 sm:px-8 lg:px-12 max-w-4xl mx-auto"
    >
      <Reveal className="mb-12 text-center">
        <Label>Frequently Asked Questions</Label>
        <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-[#3B352D]">
          Everything you're wondering
        </h2>
      </Reveal>

      <Reveal>
        <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
          {ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl bg-white border border-[#2F3B2E]/12 px-6 data-[state=open]:border-[#2F3B2E]/30"
            >
              <AccordionTrigger className="py-5 text-left font-serif-display text-lg lg:text-xl font-medium text-[#3B352D] hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-relaxed text-[#6B665C]">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
